<script>
    import {Line} from 'vue-chartjs'
    import {CustomTooltips} from '@coreui/coreui-plugin-chartjs-custom-tooltips'
    import {getStyle} from '@coreui/coreui-pro/dist/js/coreui-utilities'

    export default {
        name: 'ChartLineSmall',
        extends: Line,
        props: ['height', 'width', 'sets', 'labels'],
        watch: {
            sets: {
                handler(val) {
                    this.build()
                },
                deep: true
            },
            labels: {
                handler(val) {
                    this.build()
                },
                deep: true
            }
        },
        mounted() {
            this.build()
        },
        methods: {
            build() {
                this.renderChart(
                    {
                        labels: this.labels,
                        datasets: this.sets
                    },
                    {
                        tooltips: {
                            enabled: false,
                            custom: CustomTooltips
                        },
                        maintainAspectRatio: false,
                        legend: {
                            display: false
                        },
                        scales: {
                            xAxes: [
                                {
                                    gridLines: {
                                        color: 'transparent',
                                        zeroLineColor: 'transparent'
                                    },
                                    ticks: {
                                        fontSize: 2,
                                        fontColor: 'transparent'
                                    }
                                }
                            ],
                            yAxes: [
                                {
                                    display: false,
                                    ticks: {
                                        display: false,
                                        min: Math.min.apply(Math, this.sets[0].data) - 5,
                                        max: Math.max.apply(Math, this.sets[0].data) + 5
                                    }
                                }
                            ]
                        },
                        elements: {
                            line: {
                                borderWidth: 1
                            },
                            point: {
                                radius: 4,
                                hitRadius: 10,
                                hoverRadius: 4
                            }
                        }
                    }
                )
            }
        }
    }
</script>
